import { Flex, Text } from "@huub-web/ui";
import { focusVisible } from "@huub-web/ui/theme/css/focusVisible.css";
import { mergeClasses } from "@huub-web/utils";

import { buttonStyle, containerStyle } from "./SubCategoryItem.css";

export const SubCategoryItem = ({
  name,
  totalObservations,
  onClick,
  active,
  disabled = false,
}: {
  name: string;
  totalObservations: number;
  active: boolean;
  disabled?: boolean;
  onClick: () => void;
}) => (
  <li className={containerStyle}>
    <Flex
      direction="column"
      gap="xxs2"
      as="button"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={mergeClasses(buttonStyle({ active, disabled }), focusVisible)}
    >
      <Text variant="bodyM">{name}</Text>
      <Text variant="bodyS" color="currentColor50">
        {totalObservations} {totalObservations === 1 ? "inzicht" : "inzichten"}
      </Text>
    </Flex>
  </li>
);
